/* Speed Junkies HQ - metal 3D heading treatment.

   assets/sj-h3d.css fills these headings with a metal gradient and draws the
   3D extrusion with a ::before whose content is attr(data-text). Liquid cannot
   reliably add that attribute to every heading across every section, so it is
   added here instead.

   The heading already renders filled without this file - only the extrusion
   depends on it - so a failure here degrades quietly rather than breaking the
   page.

   This list is the UNION of the dark (chrome) and light (graphite) selector
   lists in the CSS, because both tones need the data-text attribute.

   Deliberately NOT included: .sj-w-modal__name (a winner's name in a modal,
   not a page heading) and Shopify's stock collection / product / filter
   headings.

   SELECTOR LIST MUST STAY IN SYNC WITH assets/sj-h3d.css
*/
(function () {
  'use strict';

  var SELECTOR = [
    '.sjh-hero-h',
    '.sjh .sjh-title',
    '.sj-lp-hero__h1',
    '.sj-lp-sec__title',
    '.sj-e__head h2',
    '.sj-help-hero__heading',
    '.sj-w-hero__h1',
    '.sj-w__in h2',
    '.sj-w-gal__head h2',
    '.sj-w-cta__inner h2',
    '.sj-g__in h1',
    '.sj-g__in h2',
    '.sj-g__head h2',
    '.sj-support-h2',
    '.sj-official-social__heading',
    '.company-hero__heading',
    '.company-content__section-heading',
    '.sjwm-side h2',
    '.sj-shop__head h1',
    '.sj-shop__head h2'
  ].join(',');

  function label(el) {
    /* textContent collapses the <em> accent spans into one string, which is
       what the extrusion needs - it is a solid silhouette behind the text. */
    return (el.textContent || '').replace(/\s+/g, ' ').trim();
  }

  function apply(root) {
    var scope = (root && root.querySelectorAll) ? root : document;
    var nodes;
    try {
      nodes = scope.querySelectorAll(SELECTOR);
    } catch (e) {
      return; /* bad selector on an old browser - leave the headings alone */
    }
    Array.prototype.forEach.call(nodes, function (el) {
      var text = label(el);
      if (!text) return;
      if (el.getAttribute('data-text') === text) return;
      el.setAttribute('data-text', text);
    });
  }

  function boot() {
    apply(document);

    /* Sections re-render in the theme editor, and the winners gallery swaps
       its own markup in, so re-apply when the DOM changes. */
    if (!('MutationObserver' in window)) return;
    var pending = false;
    var mo = new MutationObserver(function () {
      if (pending) return;
      pending = true;
      window.requestAnimationFrame(function () {
        pending = false;
        apply(document);
      });
    });
    mo.observe(document.documentElement, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot, { once: true });
  } else {
    boot();
  }

  /* Shopify theme editor events */
  document.addEventListener('shopify:section:load', function () { apply(document); });
  document.addEventListener('shopify:section:select', function () { apply(document); });
})();
